"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpirationPeriodCount = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var ExpirationPeriodCount = function (_a) {
    var expirationPeriod = _a.expirationPeriod;
    var t = react_i18next_1.useTranslation('common').t;
    if (expirationPeriod.days) {
        return (react_1.default.createElement("span", null, expirationPeriod.days +
            Number(Boolean(expirationPeriod.hours)) + " " + t('SUBSCRIPTION_BUTTON.EXP_DAYS_COUNT')));
    }
    else if (expirationPeriod.hours) {
        return (react_1.default.createElement("span", null, Number(Boolean(expirationPeriod.hours)) + " " + t('SUBSCRIPTION_BUTTON.EXP_DAYS_COUNT')));
    }
    else if (expirationPeriod.minutes) {
        return (react_1.default.createElement("span", null, Number(Boolean(expirationPeriod.minutes)) + " " + t('SUBSCRIPTION_BUTTON.EXP_DAYS_COUNT')));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.ExpirationPeriodCount = ExpirationPeriodCount;
